var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.876 16.022c5.044 0 5.05 7.632 0 7.632-5.044 0-5.051-7.632 0-7.632z",
    fill: "url(#ig-link_svg__paint0_linear_6030_125188)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.876 16.022c5.044 0 5.05 7.632 0 7.632-5.044 0-5.051-7.632 0-7.632z",
    fill: "url(#ig-link_svg__paint1_linear_6030_125188)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.69 10.44c-.576.006-1.19.012-1.84.013v-.003c-7.632.008-8.356.153-8.356 9.383 0 9.124.263 9.385 9.383 9.385.46 0 .913.005 1.355.01 4.364.048 7.739.085 7.96-4.768.642-14.106-.4-14.096-8.501-14.02zm3.923 3.286a1.373 1.373 0 112.747 0 1.373 1.373 0 01-2.747 0zm-10.615 6.112a5.878 5.878 0 1111.755 0 5.877 5.877 0 11-11.755 0z",
    fill: "url(#ig-link_svg__paint2_linear_6030_125188)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.69 10.44c-.576.006-1.19.012-1.84.013v-.003c-7.632.008-8.356.153-8.356 9.383 0 9.124.263 9.385 9.383 9.385.46 0 .913.005 1.355.01 4.364.048 7.739.085 7.96-4.768.642-14.106-.4-14.096-8.501-14.02zm3.923 3.286a1.373 1.373 0 112.747 0 1.373 1.373 0 01-2.747 0zm-10.615 6.112a5.878 5.878 0 1111.755 0 5.877 5.877 0 11-11.755 0z",
    fill: "url(#ig-link_svg__paint3_linear_6030_125188)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.352 16.31c-.06-5.503-.085-7.74 1.962-9.866 2.148-2.227 4.494-2.207 12.708-2.139 1.7.015 3.653.03 5.908.03 3.636.006 3.843.036 4.532.136l.04.006c3.15.453 5.542 2.692 5.846 6.577.042.519.042 17.043.002 17.552-.287 3.647-2.385 5.739-4.964 6.404-1.931.5-19.066.5-21 .003-5.324-1.377-5.197-6.595-5.056-12.341.023-.938.046-1.89.046-2.841 0-1.307-.013-2.473-.024-3.521zm14.392-7.926c.374.003.751.006 1.13.006.45 0 .885-.003 1.306-.006 3.657-.025 6.248-.042 8.217 1.927 1.961 1.96 1.947 4.508 1.927 8.285-.003.4-.005.814-.005 1.242 0 .396.001.778.003 1.145.01 2.76.018 4.746-.604 6.353-1.57 4.031-5.564 3.995-9.664 3.958a129.24 129.24 0 00-1.18-.007c-.378 0-.753.002-1.127.005-4.238.031-8.158.06-9.718-3.956-.62-1.596-.612-3.97-.603-6.554.002-.312.003-.627.003-.944 0-.39-.002-.767-.003-1.13-.01-2.761-.018-4.775.603-6.369 1.564-4.014 5.454-3.985 9.715-3.955z",
    fill: "url(#ig-link_svg__paint4_linear_6030_125188)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.352 16.31c-.06-5.503-.085-7.74 1.962-9.866 2.148-2.227 4.494-2.207 12.708-2.139 1.7.015 3.653.03 5.908.03 3.636.006 3.843.036 4.532.136l.04.006c3.15.453 5.542 2.692 5.846 6.577.042.519.042 17.043.002 17.552-.287 3.647-2.385 5.739-4.964 6.404-1.931.5-19.066.5-21 .003-5.324-1.377-5.197-6.595-5.056-12.341.023-.938.046-1.89.046-2.841 0-1.307-.013-2.473-.024-3.521zm14.392-7.926c.374.003.751.006 1.13.006.45 0 .885-.003 1.306-.006 3.657-.025 6.248-.042 8.217 1.927 1.961 1.96 1.947 4.508 1.927 8.285-.003.4-.005.814-.005 1.242 0 .396.001.778.003 1.145.01 2.76.018 4.746-.604 6.353-1.57 4.031-5.564 3.995-9.664 3.958a129.24 129.24 0 00-1.18-.007c-.378 0-.753.002-1.127.005-4.238.031-8.158.06-9.718-3.956-.62-1.596-.612-3.97-.603-6.554.002-.312.003-.627.003-.944 0-.39-.002-.767-.003-1.13-.01-2.761-.018-4.775.603-6.369 1.564-4.014 5.454-3.985 9.715-3.955z",
    fill: "url(#ig-link_svg__paint5_linear_6030_125188)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2F54EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.161 33.271c-.32 0-.621.125-.848.352l-.87.87a2.061 2.061 0 01-1.468.609 2.078 2.078 0 01-1.467-3.543l.87-.871a1.201 1.201 0 00-.848-2.048c-.32 0-.622.125-.848.351l-.871.871a4.445 4.445 0 00-1.311 3.164c0 1.196.465 2.32 1.31 3.164a4.445 4.445 0 003.165 1.311 4.445 4.445 0 003.164-1.31l.87-.872a1.201 1.201 0 00-.848-2.048z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.127 33.875c.226.226.527.351.848.351.32 0 .621-.125.848-.351l4.053-4.053c.226-.226.351-.528.351-.848 0-.32-.125-.622-.351-.849a1.192 1.192 0 00-.849-.351c-.32 0-.621.125-.848.351l-4.053 4.053a1.201 1.201 0 000 1.697z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.191 25.81a4.445 4.445 0 00-3.164-1.311 4.445 4.445 0 00-3.164 1.31l-.87.871a1.201 1.201 0 00.848 2.049c.32 0 .621-.125.848-.352l.87-.87a2.062 2.062 0 011.468-.609 2.078 2.078 0 011.468 3.543l-.871.871a1.191 1.191 0 00-.352.848c0 .32.125.622.352.849.226.226.528.351.848.351.32 0 .622-.125.849-.351l.87-.871a4.48 4.48 0 000-6.328z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-link_svg__paint0_linear_6030_125188",
    x1: 36,
    y1: 4.571,
    x2: 4.571,
    y2: 35.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-link_svg__paint1_linear_6030_125188",
    x1: 6.373,
    y1: 33.359,
    x2: 35.189,
    y2: 8.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-link_svg__paint2_linear_6030_125188",
    x1: 36,
    y1: 4.571,
    x2: 4.571,
    y2: 35.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-link_svg__paint3_linear_6030_125188",
    x1: 6.373,
    y1: 33.359,
    x2: 35.189,
    y2: 8.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-link_svg__paint4_linear_6030_125188",
    x1: 36,
    y1: 4.571,
    x2: 4.571,
    y2: 35.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-link_svg__paint5_linear_6030_125188",
    x1: 6.373,
    y1: 33.359,
    x2: 35.189,
    y2: 8.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })))));
}

export default __webpack_public_path__ + "./fonts/ig-link.a266d2614d55be9c47aceb77a6f2a792.svg";
export { SvgIgLink as ReactComponent };